import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { BsThreeDotsVertical } from "react-icons/bs";
import sha1 from 'crypto';

import FeedLayout from '../Includes/FeedLayout';
import ProfileChips from '../Includes/ProfileChips';
import api from '../../services/api';
import perfil from '../../assests/perfil.jpg';
import MenuPerfil from '../Includes/MenuPerfil';
import imgAvatar from '../../assests/avatar.png';
import { useTranslation } from 'react-i18next';
import './styles.css';

export default function PerfilEditSenha() {
  let tmpToken = "";
  const USER_EMAIL = sessionStorage.getItem('email');
  const USER_TOKEN = sessionStorage.getItem('token');
  const BASE_URL = sessionStorage.getItem('BASE_URL');
  const [old_password, setOld_password] = useState('');
  const [password, setPassword] = useState('');
  const [password_confirmation, setPassword_confirmation] = useState('');

  const hash = sha1.createHmac('sha256', USER_EMAIL)
    .update(USER_EMAIL)
    .digest('hex');

  const USER_TOKEN_TEMP = hash;

  let user = Array;
  const history = useHistory();
  const { t } = useTranslation();

  function mostrarMensagem(texto) {
    const el = document.getElementById('mensagens');
    if (!el) return;
    el.style.display = 'block';
    el.innerHTML = texto;
    setTimeout(() => {
      const atual = document.getElementById('mensagens');
      if (!atual) return;
      atual.innerHTML = '';
      atual.style.display = 'none';
    }, 5000);
  }

  function handleAlterarSenha(e) {
    e.preventDefault();
    if (password.length < 6) {
      mostrarMensagem(t('pages.profileEditPassword.messages.passwordMinLength'));
      return false;
    }
    if (password_confirmation.length < 6) {
      mostrarMensagem(t('pages.profileEditPassword.messages.passwordConfirmationMinLength'));
      return false;
    }
    if (password !== password_confirmation) {
      mostrarMensagem(t('pages.profileEditPassword.messages.diferentPasswords'));
      return false;
    }
    var axios = require('axios');
    var data = JSON.stringify({ "old_password": old_password, "password": password, "password_confirmation": password_confirmation });

    var config = {
      method: 'put',
      url: BASE_URL + `/v4/users/me/update_password`,
      headers: {
        'USER_EMAIL': USER_EMAIL,
        'USER_TOKEN': USER_TOKEN,
        'Content-Type': 'application/json'
      },
      data: data
    };

    axios(config)
      .then(function (response) {
        history.push('/perfil');
      })
      .catch(function (error) {
      });
  }

  return (
    <FeedLayout active="profile">
    <div className="edit-senha-container">
      <div className="feed-top">{t('pages.profileEditPassword.title')}</div>
      <ProfileChips active="profile" />
      <section className="body">
        <form onSubmit={handleAlterarSenha} ectype="multipart/form-data">
          <div className="conteudo">
            <div className="perfil">
              <div className="perfil-campos">
                <label>
                  {t('pages.profileEditPassword.labels.currentPassword')}
                  <input
                    id="old_password"
                    type="password"
                    value={old_password}
                    onChange={e => setOld_password(e.target.value)}
                  />
                </label>
                <label>
                  {t('pages.profileEditPassword.labels.newPassword')}
                  <input
                    type="password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                  />
                </label>
                <label>
                  {t('pages.profileEditPassword.labels.confirmationNewPassword')}
                  <input
                    type="password"
                    value={password_confirmation}
                    onChange={e => setPassword_confirmation(e.target.value)}
                  />
                </label>
                <button type="submit" className="btnEnviar">{t('pages.profileEditPassword.buttons.update')}</button>
              </div>
            </div>
            <MenuPerfil />
          </div>
          <div id="mensagens" className="msg erro">ESTA DIV É PARA MENSAGENS!!!</div>
        </form>
      </section>
    </div>
    </FeedLayout>
  )
}